import "../plugins/templates";
import MapPlaces from "../maps/mapPlaces";
import getGebietForPlz from '../maps/contactPersonData';

window.contactPersonMap = {};

(function () {

    contactPersonMap = new MapPlaces({
        renderMapsInfoBox: hbs.templates.locationMap[mapSettings.mapsInfoBox ? mapSettings.mapsInfoBox : 'mapsInfoBox'],
        defaultIcon: mapSettings.mapIcon,
        hoverIcon: mapSettings.mapIconHover
    });

    contactPersonMap.initMap2 = function () {
        this.initMap();
        this.setPlaces(places);
        var map = this.getMap();
        if (mapSettings.zoomLevel > 0) {
            var listener = google.maps.event.addListener(map, "idle", function () {
                map.setZoom(mapSettings.zoomLevel);
                google.maps.event.removeListener(listener);
            });
        }
    };

    const $searchForm = $('#cpmSearchForm');
    const $searchCity = $('#cpmSearchCity');
    const $searchZip = $('#cpmSearchZip');

    $searchForm.find('input:checkbox').change(function (e) {
        formSubmit();
    });
    $searchZip.keypress(submitByEnter);
    $searchZip.on('change', submitSearchForm);

    $searchForm.on('submit', function (e) {
        e.preventDefault();
        let zip = $searchZip.val();
        let area = getGebietForPlz(zip);
        contactPersonMap.clickMarkerByIndex(area);
    });

    $searchZip.keyup(function () {
        if ($searchZip.val().length === 5) {
            $searchZip.removeClass('is-invalid');
            $.ajax({
                url: "https://api.zippopotam.us/de/" + $searchZip.val(),
                cache: false,
                dataType: "json",
                type: "GET",
                success: function (result, success) {
                    // German Post Code Records Officially Map to only 1 Primary Location
                    var places = result['places'][0];
                    $searchCity.val(places['place name'] + ', ' + places['state']);
                    $searchCity.removeClass('is-invalid');
                    formSubmit();
                },
                error: function (result, success) {
                    $searchCity.val('Ort nicht gefunden');
                    $searchCity.addClass('is-invalid');
                }
            });
        } else if ($searchZip.val().length !== 0) {
            $searchZip.addClass('is-invalid');
        } else {
            $searchZip.removeClass('is-invalid');
        }
    });

    function submitByEnter(e) {
        if (e.which === 13) {
            e.preventDefault();
            formSubmit();
        }
    }

    function formSubmit() {
        if ($searchZip.val().length === 5) {
            submitSearchForm();
        }
    }

    function submitSearchForm() {
        $searchForm.submit();
    }

})();
